import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Coins, LogOut, User as UserIcon } from "lucide-react";

export default function Navbar({ minimal = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header
      className="w-full border-b border-black/10 bg-white/80 backdrop-blur-xl sticky top-0 z-50"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-0 group"
          data-testid="navbar-logo-link"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_reel-hook/artifacts/oaoycnla_ChatGPT%20Image%20Apr%2020%2C%202026%2C%2001_20_23%20AM.png"
            alt="Jingle Hooks"
            className="h-14 w-14 object-contain shrink-0"
          />
          <span className="font-display text-xl font-semibold tracking-tight -ml-2">
            Jingle Hooks
          </span>
        </Link>

        {!minimal && (
          <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
            <Link
              to="/about"
              className="hover:text-[#FF4500] transition-colors"
              data-testid="navbar-about-link"
            >
              About
            </Link>
            <Link
              to="/pricing"
              className="hover:text-[#FF4500] transition-colors"
              data-testid="navbar-pricing-link"
            >
              Pricing
            </Link>
            {user && (
              <Link
                to="/dashboard"
                className="hover:text-[#FF4500] transition-colors"
                data-testid="navbar-dashboard-link"
              >
                Dashboard
              </Link>
            )}
          </nav>
        )}

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <Link
                to="/credits"
                className="hidden sm:flex items-center gap-2 px-3 h-9 border border-black/10 bg-[#F8F9FA] hover:border-[#FF4500] hover:bg-white transition-colors"
                data-testid="navbar-credits"
                title="View credits & top up"
              >
                <Coins size={16} className="text-[#FF4500]" />
                <span className="text-sm font-semibold tabular-nums">
                  {user.credits}
                </span>
                <span className="text-xs text-zinc-500">credits left</span>
              </Link>
              <Link to="/generate" data-testid="navbar-generate-link">
                <Button
                  className="bg-[#FF4500] hover:bg-[#E03C00] text-white rounded-sm h-9 px-4"
                  data-testid="navbar-generate-btn"
                >
                  Create jingle
                </Button>
              </Link>
              <button
                onClick={handleLogout}
                className="w-9 h-9 border border-black/10 flex items-center justify-center hover:bg-black hover:text-white transition-colors"
                title="Logout"
                data-testid="navbar-logout-btn"
              >
                <LogOut size={16} />
              </button>
            </>
          ) : (
            <Link to="/login" data-testid="navbar-login-link">
              <Button
                className="bg-black hover:bg-zinc-800 text-white rounded-sm h-9 px-5"
                data-testid="navbar-login-btn"
              >
                Sign in
              </Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
